import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=107c9414"
import script from "./emailTemplate.vue?vue&type=script&lang=js"
export * from "./emailTemplate.vue?vue&type=script&lang=js"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=107c9414&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports